// ⚠️ GENERATED COPY — DO NOT EDIT.
// Source: shared/lib/journeySteps.ts — edit there, then run: bash scripts/sync_shared_code.sh
// CI verifies these copies match the source (sync_shared_code.sh --check).
// Pure stepper state, kept out of the component so it can be tested without a DOM.
export type JourneyStep = { key: string; label: string };

export type JourneyStepState = JourneyStep & {
  index: number;
  number: string;
  done: boolean;
  current: boolean;
  upcoming: boolean;
  hasLine: boolean;
};

// currentKey null means the journey has not started (a welcome screen), so no
// step is current. An unknown key is treated the same way rather than guessing.
export function journeyStepStates(
  steps: JourneyStep[],
  currentKey: string | null,
  doneAll = false,
): JourneyStepState[] {
  const currentIndex = currentKey === null ? -1 : steps.findIndex((s) => s.key === currentKey);
  const last = steps.length - 1;
  return steps.map((step, index) => {
    const done = doneAll || (currentIndex >= 0 && index < currentIndex);
    const current = !doneAll && index === currentIndex;
    return {
      ...step,
      index,
      number: String(index + 1),
      done,
      current,
      upcoming: !done && !current,
      hasLine: index < last,
    };
  });
}

// The patient's leg of a link: their details, the fee step (only when the
// bridge says a fee applies to this form), the questions, signing, done. The
// fee step is spliced in, never shown greyed: a patient with no fee never
// learns the step exists.
export const PATIENT_STEPS_BASE: JourneyStep[] = [
  { key: "details", label: "Your details" },
  { key: "questions", label: "Questions" },
  { key: "sign", label: "Sign" },
  { key: "done", label: "Done" },
];

export const PATIENT_FEE_STEP: JourneyStep = { key: "fee", label: "Fee" };

export function patientSteps(feeApplies: boolean): JourneyStep[] {
  if (!feeApplies) return PATIENT_STEPS_BASE.slice();
  return [PATIENT_STEPS_BASE[0], PATIENT_FEE_STEP, ...PATIENT_STEPS_BASE.slice(1)];
}
